import { render, staticRenderFns } from "./LogsView.vue?vue&type=template&id=78a485b2"
import script from "./LogsView.vue?vue&type=script&setup=true&lang=js"
export * from "./LogsView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports